import Api from "./api";

export default {
  async setFiscalCode(config, fiscalCode) {
    const response = await Api(config).patch(`${config.api.setFiscalCode}`, { fiscal_code: fiscalCode });
    return response.data;
  },
  async getFiscalCode(config) {
    const response = await Api(config).get(`${config.api.setFiscalCode}`);
    return response.data;
  },
};
